export enum AlertMessageConstants {
    PythonCodeExecutionSuccess = "Code execution completed successfully.",
    PythonCodeExecutionError = "Code execution failed.",
    PythonCodeExecutionAlreadyRunning = "Please wait. Code is running on server.",
    // PythonCodeNoWritten="Please write code in editor."
}